import dayjs from 'dayjs'
import { Badge, TTableDataCountDisplay, TTableHeader, TTableProps, TableCellSplit } from '@reapitform/common-ui'
import { AgreementListItem } from '../../../../api/types/agreements'
import { documentStatusIntent, documentStatusMapping } from '../../../../utils/documents'

const tableHeader: TTableHeader<AgreementListItem>[] = [
  {
    headerTitle: 'PROPERTY',
    key: 'referenceID',
    getColumnValue: (data) => {
      const address: AgreementListItem['propertyAddress'] = data.propertyAddress
      if (!address) return
      const addressMain: string = [address.unitNo, address.streetNo, address?.street, address.streetType]
        .filter((address) => address)
        .join(' ')
      const addressSub: string = [address.suburb, address.state, address.postCode]
        .filter((address) => address)
        .join(' ')

      return <TableCellSplit isTitleMediumBold data={addressMain || '-'} subData={addressSub || '-'} />
    },
  },
  {
    headerTitle: 'AGREEMENT',
    key: 'formName',
    getColumnValue: (data) => (
      <TableCellSplit
        data={data.formName ?? '-'}
        subData={data.dateCreatedUTC ? 'Created ' + dayjs(data.dateCreatedUTC).format('D MMM YYYY') : '-'}
      />
    ),
  },
  {
    headerTitle: 'SIGNEES',
    key: 'recipients',
    getColumnValue: (data) => data.recipients?.join(', ') || '-',
    showTooltipWhenTruncated: true,
    disableWordWrap: true,
  },
  {
    headerTitle: 'SIGNED',
    key: 'signedCount',
    columnWidth: '90px',
    getColumnValue: (data) => `${data.signedCount ?? 0}/${data.recipients?.length ?? 0}`,
  },
  {
    headerTitle: 'STATUS',
    key: 'status',
    columnWidth: '120px',
    getColumnValue: (data) => (
      <Badge intent={documentStatusIntent[data.status]}>{documentStatusMapping[data.status]}</Badge>
    ),
  },
  {
    headerTitle: 'LAST ACTION',
    key: 'lastActionUTC',
    columnWidth: '160px',
    getColumnValue: (data) => (
      <TableCellSplit
        data={data.lastAction}
        subData={data.lastActionUTC ? dayjs(data.lastActionUTC).format('D MMM YYYY, h:mma') : undefined}
      />
    ),
    sortable: true,
    sortAs: 'LastActionDate',
    sortValue: 'Descending',
  },
]

const tableCountDisplayConfig: TTableDataCountDisplay = {
  singular: 'agreement',
  plural: 'agreements',
}

export const agreementListTableConfig: Pick<
  TTableProps<AgreementListItem>,
  'headers' | 'tableDataCountMessage' | 'emptyMessage'
> = {
  headers: tableHeader,
  tableDataCountMessage: tableCountDisplayConfig,
  emptyMessage: 'No agreements found',
}
